import { render, staticRenderFns } from "./imageBannerSettingLR.vue?vue&type=template&id=3ed28f1c&scoped=true"
import script from "./imageBannerSettingLR.vue?vue&type=script&lang=js"
export * from "./imageBannerSettingLR.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ed28f1c",
  null
  
)

export default component.exports